import { FC } from "react";
import { useEffect } from 'react';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import './carousel-style.css';
import ServiceCard from "./ServiceCard";

import serviceConfig from "content/services/services.json"
import { ServicesPageId } from "utils/useScroll";
import { PageHeader } from "shared/page-header/PageHeader";
import { Box } from "@chakra-ui/react";
export const Services: FC = () => {

  useEffect(() => {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  }, []);



  return (

    <Box id={ServicesPageId}>
    <PageHeader label="Services" />
    <div style={{
      paddingBottom: '10px',
      position: 'relative',
      height: "auto", // Changed from fixed height
    }}>
      <Carousel
        additionalTransfrom={0}
        arrows
        autoPlaySpeed={3000}
        autoPlay
        centerMode={false}
        containerClass="service-carousel-container" // Added custom class
        dotListClass=""
        draggable
        focusOnSelect={false}
        infinite
        itemClass="service-carousel-item" // Added custom class
        keyBoardControl
        minimumTouchDrag={80}
        pauseOnHover
        renderArrowsWhenDisabled={false}
        renderButtonGroupOutside={false}
        renderDotsOutside
        responsive={{
          desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
          },
          mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
          },
          tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
          }
        }}
        rewind={false}
        rewindWithAnimation={true}
        rtl={false}
        shouldResetAutoplay
        showDots
        sliderClass=""
        slidesToSlide={1}
        swipeable
      >
        {serviceConfig.serviceData.map((service, idx) => (
          <div 
            key={idx}
            style={{
              height: "100%",
              padding: "0 20px",
              boxSizing: "border-box",
              display: "flex",
              justifyContent: "center"
            }}
          >
            <ServiceCard
              description={service.description}
              headline={service.headline}
              image={service.image}
              targetPageId={service.learnMoreLink}
              route={service.route}
            />
          </div>
        ))}
      </Carousel>
    </div>
  </Box>


  )
}
export default Services;
